import { PublicClientApplication } from '@azure/msal-browser'

const clientId = import.meta.env.VITE_AZURE_CLIENT_ID
const tenantId = import.meta.env.VITE_AZURE_TENANT_ID

if (!clientId || !tenantId) {
  throw new Error(
    'Missing VITE_AZURE_CLIENT_ID / VITE_AZURE_TENANT_ID env vars — Microsoft sign-in cannot be configured.',
  )
}

export const msalInstance = new PublicClientApplication({
  auth: {
    clientId,
    authority: `https://login.microsoftonline.com/${tenantId}`,
    redirectUri: window.location.origin,
    postLogoutRedirectUri: window.location.origin,
  },
  cache: { cacheLocation: 'localStorage' },
})

// Scope for our own backend API (Expose an API → access_as_user).
export const loginRequest = {
  scopes: [`api://${clientId}/access_as_user`],
}
